export const USER_ALL = '[User] All';
export const USER_Token = '[User] Token';
export const USER_RefreshToken = '[User] Refresh Token';
export const USER_CurentClient = '[User] Current Client';
export const USER_CurentBusType = '[User] Current Business Type';
export const USER_CurentBusSubType = '[User] Current Business Sub Type';
export const USER_Logout = '[User] Logout';
